var React = require('react');

function Reception (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"25","y":"116.1","width":"142.9","height":"17.9","rx":"3","transform":"rotate(-.1 25 116.1)","stroke":"#000","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M33.2 115.4A62 62 0 0 1 95 55.2h1.8A62 62 0 0 1 159 115l-125.8.3Z","stroke":"#000","strokeWidth":"4","key":1}),React.createElement("path",{"d":"M119 72c5.5 1.7 18 8.8 24 24","stroke":"#000","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M108 57a12 12 0 0 0-24 0","stroke":"#000","strokeWidth":"4","key":3})]);
}

Reception.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Reception;

Reception.default = Reception;
